import React from 'react'
import { useTranslation } from 'react-i18next'
import { MenuItem } from '../../../../common/components/MenuItem/MenuItem'
import { MENU_ITEM_TYPE_SUBMENU, USER_MENU_LANGUAGE } from '../../../../common/constants'
import styles from '../../UserMenu.module.css'

export const PlayerAccountMenu: React.FC<{
  onMenuItemClick: (menuItemName: string) => void
  activeLanguage: string
}> = ({ onMenuItemClick, activeLanguage }) => {
  const onMenuItemClickInternal = (menuItemName: string) => {
    onMenuItemClick(menuItemName)
  }
  const { t } = useTranslation()

  return (
    <>
      <MenuItem
        fontSize='normal'
        icon='language'
        text={t('user_menu.language', 'Language')}
        activeLanguage={activeLanguage}
        menuItemName={USER_MENU_LANGUAGE}
        itemType={MENU_ITEM_TYPE_SUBMENU}
        isUserMenu
        onMenuItemClick={onMenuItemClickInternal}
      />
      <MenuItem
        fontSize='normal'
        icon='settings'
        text={t('user_menu.reset_password', 'Reset password')}
        activeLanguage={activeLanguage}
        menuItemName='reset-password'
        isUserMenu
        onMenuItemClick={onMenuItemClickInternal}
      />
      <MenuItem
        fontSize='normal'
        icon='text'
        text={t('user_menu.help', 'Help')}
        activeLanguage={activeLanguage}
        menuItemName='help'
        isUserMenu
        onMenuItemClick={onMenuItemClickInternal}
      />
      <div className={styles.rowSeparator} />
      <MenuItem
        fontSize='normal'
        icon='logout'
        text={t('user_menu.log_out', 'Log out')}
        menuItemName='logout'
        isUserMenu
        onMenuItemClick={onMenuItemClickInternal}
      />
    </>
  )
}
